class CustomFaqMetaobject extends HTMLElement {
  constructor() {
    super();
    this._initialized = false;
    this._listeners = [];
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;
    this.initAccordion();
  }

  disconnectedCallback() {
    this._listeners.forEach(({ target, type, handler }) =>
      target.removeEventListener(type, handler)
    );
    this._listeners = [];
    this._initialized = false;
  }

  _openItem(item, questionWrap) {
    const answer = item.querySelector('.faq-meta-answer');
    const icon = item.querySelector('.faq-meta-icon');

    item.classList.add('is-open');
    questionWrap.setAttribute('aria-expanded', 'true');

    if (answer) answer.style.display = 'block';
    questionWrap.style.marginBottom = '0px';
    if (icon) icon.style.transform = 'rotate(180deg)';
  }

  _closeItem(item, questionWrap) {
    const answer = item.querySelector('.faq-meta-answer');
    const icon = item.querySelector('.faq-meta-icon');

    item.classList.remove('is-open');
    questionWrap.setAttribute('aria-expanded', 'false');

    if (answer) answer.style.display = 'none';
    questionWrap.style.marginBottom = '15px';
    if (icon) icon.style.transform = 'rotate(0deg)';
  }

  initAccordion() {
    const faqItems = Array.from(this.querySelectorAll('.faq-meta-item'));
    const questionWraps = faqItems
      .map((item) => item.querySelector('.faq-meta-q-wrap'))
      .filter(Boolean);

    faqItems.forEach((item, index) => {
      const questionWrap = item.querySelector('.faq-meta-q-wrap');
      if (!questionWrap) return;

      const answer = item.querySelector('.faq-meta-answer');
      const icon = item.querySelector('.faq-meta-icon');

      // Setup Initial Styles
      questionWrap.style.cursor = 'pointer';
      questionWrap.style.userSelect = 'none';
      questionWrap.style.marginBottom = '15px';
      questionWrap.style.transition = 'margin-bottom 0.3s ease';

      if (answer) {
        answer.style.display = 'none';
        answer.style.overflow = 'hidden';
      }

      if (icon) {
        icon.style.marginLeft = 'auto';
        icon.style.flexShrink = '0';
        icon.style.transition = 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)';
        icon.style.display = 'flex';
        icon.style.alignItems = 'center';
        icon.style.paddingTop = '10px';
      }

      const toggleAccordion = () => {
        if (item.classList.contains('is-open')) {
          this._closeItem(item, questionWrap);
        } else {
          faqItems.forEach((other) => {
            if (other !== item && other.classList.contains('is-open')) {
              this._closeItem(other, other.querySelector('.faq-meta-q-wrap'));
            }
          });
          this._openItem(item, questionWrap);
        }
      };

      const handleKeydown = (e) => {
        const keys = {
          Enter: toggleAccordion,
          ' ': toggleAccordion,
          ArrowDown: () => questionWraps[(index + 1) % questionWraps.length].focus(),
          ArrowUp: () =>
            questionWraps[(index - 1 + questionWraps.length) % questionWraps.length].focus(),
          Home: () => questionWraps[0].focus(),
          End: () => questionWraps[questionWraps.length - 1].focus(),
          Escape: () => questionWrap.blur(),
        };

        if (keys[e.key]) {
          e.preventDefault();
          keys[e.key]();
        }
      };

      questionWrap.addEventListener('click', toggleAccordion);
      questionWrap.addEventListener('keydown', handleKeydown);

      this._listeners.push(
        { target: questionWrap, type: 'click', handler: toggleAccordion },
        { target: questionWrap, type: 'keydown', handler: handleKeydown }
      );
    });
  }
}

if (!customElements.get('custom-faq-metaobject')) {
  customElements.define('custom-faq-metaobject', CustomFaqMetaobject);
}
